import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import {email, required} from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

localize('en', en)

extend('required', {
  ...required,
  message: 'This field is required'
})

extend('email', {
  ...email,
  message: 'The field must be a valid email address'
});

extend('price', {
  validate: value => /^\d+(\.\d+)?$/.test(value),
  message: 'Only numbers and a decimal point are allowed'
})


Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
